import screenConfig, {
    BUSINESS_TYPE,
    SECTIONS as dataCollectionSections
} from './screenConfig';

export const uiTypes = {
    START_PROCESSING: 'START_PROCESSING',
    STOP_PROCESSING: 'STOP_PROCESSING'
};

export const formTypes = {
    UPDATE_FIELD: 'UPDATE_FIELD',
    UPDATE_FIELDS: 'UPDATE_FIELDS',
    UPDATE_ARRAY_FIELD: 'UPDATE_ARRAY_FIELD',
    CLEAR_FIELDS: 'CLEAR_FIELDS'
};

export const errorTypes = {
    UPDATE_ERROR: 'UPDATE_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR'
};

export const termsContent = (locale: string) => ({
    agreementLink: `https://www.paypal.com/us/webapps/mpp/ua/useragreement-full?locale.x=${locale}`,
    privacyLink: `https://www.paypal.com/us/webapps/mpp/ua/privacy-full?locale.x=${locale}`,
    termsLink: `https://www.paypal.com/us/webapps/mpp/ua/zettle-tnc?locale.x=en_US`, //For the Zettle US launch, we will only have terms in English.
    eComLink: `https://www.paypal.com/us/webapps/mpp/ua/esign-full?locale.x=${locale}`
});

export const UBO_FLAGS = {
    IS_DIRECTORS: 'isDirector',
    BENEFICIAL_OWNER: 'beneficialOwner',
    TOP_LEVEL_MANAGEMENT: 'topLevelManagement'
};

export const REGISTERED_CHARITY_MCC_CODE = '8398';

export const FIELDS_TO_COLLECT = {
    BIZ_TYPE: 'businessType',
    BIZ_NAME: 'businessName',
    MCC: 'merchantCategoryCode',
    IS_ENTITY: 'businessEntity',
    EIN: 'ein',
    BIZ_ADDRESS: 'businessAddress',
    BIZ_PHONE: 'businessPhoneNumber',
    HOME_ADDRESS: 'homeAddress',
    DOB: 'dateOfBirth',
    SSN: 'ssn',
    CONFIRM_SSN: 'reTypeSSN',
    MOBILE_PHONE: 'personalPhoneNumber',
    WEBSITE: 'businessWebsite',
    WEBSITE_EXISTS: 'businessWebsiteExists'
};

// CTA - call to action
export const NEED_DATA_CTA_URL = {
    US:
        '/policydashboard/process/compliance/usonboarding?returnUrl=%2Fcponboarding%2Freview', // doc upload dexter url
    GB: '/policydashboard/process/compliance/kyc_lite' // GB adroit URL
};
// GRR = Global restrictions revamp
export const GRR_DASHBOARD_URL = '/restore/dashboard';

export const LOGO_PAYPAL_COLOR =
    'https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-color.svg';
export const PAYPAL_MARK_LOGO =
    'https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg';

export const US_TERRITORIES = [
    'AS',
    'GU',
    'MP',
    'PR',
    'VI',
    'FM',
    'MH',
    'PW',
    'AE',
    'AP',
    'AA'
];

export const URL_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;

export const UL_LOGIN_REDIRECT_URL = `${window.location.origin}/signin/?returnUri=${window.location.origin}/cponboarding/upgrade`;

export const ONBOARDING_EXPERIENCE = {
    NET_NEW: 'net_new',
    UPGRADE: 'upgrade'
};
export const ZETTLE_URL = 'https://www.zettle.com/';

export const actionFields = {
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    PASSWORD: 'password',
    BUSINESS_TYPE: 'bizType',
    BUSINESS_NAME: 'bizName',
    IS_US_ENTITY: 'isUSBusinessEntity',
    IS_UK_REGISTERED: 'isUKRegistered',
    EIN: 'ein',
    MCC: 'mcc',
    SSN: 'ssn',
    BACKUP_WITHHOLDING: 'backupWithholding',
    ITIN: 'itin',
    BUSINESS_PHONE_NUMBER: 'businessNumber',
    MOBILE_PHONE_NUMBER: 'mobileNumber',
    BUSINESS_ADDRESS: 'businessAddress',
    HOME_ADDRESS: 'homeAddress',
    DATE_OF_BIRTH: 'dob',
    IS_US_CITIZEN: 'isUSCitizen',
    NATIONALITY: 'nationality',
    SAME_ADDRESS_CHECK: 'sameAddressCheck',
    AVERAGE_MONTHLY_VOLUME: 'averageMonthlyVolume',
    HAS_BENEFICIARY: 'hasBeneficiary',
    IS_COMPANYHOUSE_REGISTERED: 'isCompanyHouseRegistered',
    NON_PROFIT_REGISTRY: 'nonProfitRegistry',
    BUSINESS_REGISTRATION_NUMBER: 'businessRegistrationNumber',
    CHARITY_REGISTRATION_NUMBER: 'charityRegistrationNumber',
    STAKEHOLDERINFO: 'stakeholders',
    DIRECTORS: 'directors',
    BENEFICIARY: 'beneficiary',
    TOPLEVELMANAGEMENT: 'topLevelManagement',
    BUSINESS_LOCATION_TYPES: 'pointOfSaleLocation',
    BUSINESS_FREQUENCY: 'seasonalBusiness',
    BUSINESS_AVERAGE_TRANSACTION: 'averageTransaction',
    BUSINESS_IZETTLE_SHARE_OF_TURNOVER: 'iZettleTurnoverPercentage',
    BUSINESS_CURRENT_ANNUAL_TURNOVER: 'currentAnnualTurnover',
    BUSINESS_EXPECTED_ANNUAL_TURNOVER: 'expectedAnnualTurnover',
    IS_CONSUMER_UPGRADE: 'isConsumerUpgrade',
    IS_BUSINESS_UPGRADE: 'isBusinessUpgrade',
    IS_MINIMAL_ACCOUNT_CREATED: 'isMinimalAccountCreated',
    SKIP_UBO_FOR_UPGRADE: 'skipUBOForUpgrade',
    COUNTRY_OF_INCORPORATION: 'countryOfIncorporation'
};

export const NON_PROFIT_REGISTRATION_OPTIONS = {
    REGISTERED_COMPANY_HOUSE: 'REGISTERED_COMPANY_HOUSE',
    REGISTERED_CHARITY_COMMISSION: 'REGISTERED_COMPANY_COMMISSION'
};

export const PHONE_OTP_DECISION_CODE = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    VALIDATION_PASSED: 'VALIDATION_PASSED'
};

export const TENANT = {
    VENMO: 'venmo'
};

export const MAP_ZETTLE_SUPPORTED_BIZ_TYPE = {
    INDIVIDUAL: 'INDIVIDUAL',
    PARTNERSHIP: 'PARTNERSHIP',
    CORPORATION: 'PRIVATE_CORPORATION',
    NONPROFIT: 'NONPROFIT',
    PROPRIETORSHIP: 'INDIVIDUAL',
    GENERAL_PARTNERSHIP: 'PARTNERSHIP',
    PUBLIC_COMPANY: 'PRIVATE_CORPORATION',
    PROPRIETORY_COMPANY: 'PARTNERSHIP',
    PRIVATE_CORPORATION: 'PRIVATE_CORPORATION',
    LIMITED_PARTNERSHIP: 'PARTNERSHIP',
    LIMITED_LIABILITY_PROPRIETORS: 'PRIVATE_CORPORATION',
    LIMITED_LIABILITY_PARTNERSHIP: 'PARTNERSHIP',
    LIMITED_LIABILITY_PRIVATE_CORPORATION: 'PRIVATE_CORPORATION',
    LIMITED_PARTNERSHIP_PRIVATE_CORPORATION: 'PARTNERSHIP',
    PUBLIC_CORPORATION: 'PRIVATE_CORPORATION',
    PROPRIETORSHIP_CRAFTSMAN: 'PARTNERSHIP',
    PUBLIC_PARTNERSHIP: 'PARTNERSHIP',
    PRIVATE_PARTNERSHIP: 'PARTNERSHIP'
};

export const PHONE_COUNTRY_CODE = {
    GB: '44'
};

export { BUSINESS_TYPE, screenConfig, dataCollectionSections };
